import { render, staticRenderFns } from "./PopoverOrganization.vue?vue&type=template&id=3c13305c"
import script from "./PopoverOrganization.vue?vue&type=script&lang=js"
export * from "./PopoverOrganization.vue?vue&type=script&lang=js"
import style0 from "./PopoverOrganization.vue?vue&type=style&index=0&id=3c13305c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports